module.exports = __webpack_public_path__ + "media/img/bg-half-bcf7adf68cbc279336d53b6d22de7b9e.png";